import type { AgentReadModel } from '@gasbi/shared/common/features/agents';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Option, Select, Typography } from '@mui/joy';

type AgentSelectProps = {
  agents: AgentReadModel[];
  value?: string;
  onChange: (agentId: string) => void;
  /** The panel shows the bare name under its title; the full page frames it as «Агент: …». */
  compact?: boolean;
};

/** The agent of the conversation; another one starts a new conversation (see `useAgentChat`). */
export const AgentSelect = ({
  agents,
  value,
  onChange,
  compact = false,
}: AgentSelectProps) => (
  <Select
    size='sm'
    variant={compact ? 'plain' : 'outlined'}
    value={value ?? null}
    placeholder='Агент'
    onChange={(_, next) => next && onChange(next)}
    indicator={<KeyboardArrowDownIcon fontSize='small' />}
    startDecorator={
      compact ? undefined : (
        <Typography level='body-sm' textColor='neutral.500'>
          Агент:
        </Typography>
      )
    }
    slotProps={{ button: { 'aria-label': 'Агент' } }}
    sx={
      compact
        ? {
            px: 0,
            minHeight: 0,
            fontSize: 'xs',
            color: 'neutral.600',
            alignSelf: 'flex-start',
            '&:hover': { bgcolor: 'transparent' },
          }
        : { minWidth: 200 }
    }
  >
    {agents.map(agent => (
      <Option key={agent.id} value={agent.id}>
        {agent.name}
      </Option>
    ))}
  </Select>
);
